import { GetterTree } from 'vuex'
import { StatisticState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<StatisticState, RootState> = {
  emailStatisticDetail: state => state.emailStatisticDetail,
  emailStatisticDetailFlag: state => state.emailStatisticDetailFlag,

  emailStatisticGroup: state => state.emailStatisticGroup,
  emailGroupBy: state => state.emailGroupings.emailGroup,
  emailGroupByOptionally: state => state.emailGroupings.emailGroupByOptionally,
  emailMessageCount: state => state.emailMessageCount,

  emailIncomingGroupBy: state => state.emailGroupings.emailGroupIncoming,

};
